function get_current_lang() {
  var keyValue = document.cookie.match("(^|;) ?googtrans=([^;]*)(;|$)");
  return keyValue ? keyValue[2].split("/")[2] : null;
}

function fire_event(element, event) {
  try {
    if (document.createEventObject) {
      var evt = document.createEventObject();
      element.fireEvent("on" + event, evt);
    } else {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true);
      element.dispatchEvent(evt);
    }
  } catch (e) {}
}

function doTranslate(lang_pair) {
  if (lang_pair.value) lang_pair = lang_pair.value;
  if (lang_pair == "") return;
  var lang = lang_pair.split("|")[1];
  if (get_current_lang() == null && lang == lang_pair.split("|")[0]) return;
  var teCombo;
  var sel = document.getElementsByTagName("select");
  for (var i = 0; i < sel.length; i++) if (sel[i].className.indexOf("goog-te-combo") != -1) {
    teCombo = sel[i];
    break;
  }
  if (document.getElementById("google_translate_element_custom") == null || document.getElementById("google_translate_element_custom").innerHTML.length == 0 || teCombo.length == 0 || teCombo.innerHTML.length == 0) {
    setTimeout(function () {
      doTranslate(lang_pair);
    }, 500);
  } else {
    teCombo.value = lang;
    fire_event(teCombo, "change");
    fire_event(teCombo, "change");
  }
}

(function () {
    var translate = {};
    var lang_array_english = {
        en: "<img class='flag' src=\"//www.bridgetronic.com/cdn/shop/t/2/assets/en.png?v=17294098706615982991718717947\" alt='English'> English",
        "zh-TW": "<img class='flag' src=\"//www.bridgetronic.com/cdn/shop/t/2/assets/zh-TW.png?v=41198621985165917251718717989\" alt='Chinese'> Chinese (Traditional)",
        fr: "<img class='flag' src=\"//www.bridgetronic.com/cdn/shop/t/2/assets/fr.png?v=143035824911100638231718717308\" alt='French'> French",
        de: "<img class='flag' src=\"//www.bridgetronic.com/cdn/shop/t/2/assets/de.png?v=140174905868835639841718717307\" alt='German'> German",
        ja: "<img class='flag' src=\"//www.bridgetronic.com/cdn/shop/t/2/assets/ja.png?v=143266133912442932801718717999\" alt='Japanese'> Japanese",
        ko: "<img class='flag' src=\"//www.bridgetronic.com/cdn/shop/t/2/assets/ko.png?v=19544882054972891911718718007\" alt='Korean'> Korean"
      };

    var default_language = translate.default_language || "auto";
    var languages = translate.languages || Object.keys(lang_array_english);
    var detect_browser_language = translate.detect_browser_language || false;
    var wrapper_selector = ".translate_wrapper";

    var current_lang = document.querySelector("html").getAttribute("lang") || default_language;
    var googtrans_matches = document.cookie.match("(^|;) ?googtrans=([^;]*)(;|$)");
    current_lang = googtrans_matches && googtrans_matches[2].split("/")[2] || current_lang;
    
    function load_tlib() {
      if (!window.google_translate_script) {
        window.google_translate_script = document.createElement("script");
        google_translate_script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        document.body.appendChild(google_translate_script);
      }
    }
    
    window.googleTranslateElementInit = function () {
      new google.translate.TranslateElement({pageLanguage: default_language, autoDisplay: false}, "google_translate_element_custom");
    };
    if (current_lang != default_language) load_tlib(); else document.querySelectorAll(wrapper_selector).forEach(function (e) {
      e.addEventListener("pointerenter", load_tlib);
    });

    document.querySelectorAll('.lang-dropdown-item').forEach(function(item) {
      item.addEventListener('click', function() {
          var selectedText = this.innerHTML;
          var selectedValue = this.getAttribute('data-value');
          document.querySelectorAll(".languageDropdown").forEach(function (e) {
            e.innerHTML = selectedText;
          });
          
          var translateOptions = document.getElementById('translate_options');
          translateOptions.value = selectedValue;
          var event = new Event('change');
          translateOptions.dispatchEvent(event);
      });
    });

    document.querySelectorAll("#translate_options").forEach(function (e) {
      e.addEventListener("change", function (evt) {
        evt.preventDefault();
        doTranslate(default_language + "|" + evt.target.value);
      });
    });
    
    if (detect_browser_language && window.sessionStorage && window.navigator && sessionStorage.getItem("translate_autoswitch") == null && !/bot|spider|slurp|facebook/i.test(navigator.userAgent)) {
      var accept_language = (navigator.language || navigator.userLanguage).toLowerCase();
      switch (accept_language) {
        case "zh":
        case "zh-cn":
          var preferred_language = "zh-CN";
          break;
        case "zh-tw":
        case "zh-hk":
          var preferred_language = "zh-TW";
          break;
        case "he":
          var preferred_language = "iw";
          break;
        default:
          var preferred_language = accept_language.substr(0, 2);
          break;
      }
      if (current_lang == default_language && preferred_language != default_language && languages.includes(preferred_language)) {
          load_tlib();
          window.google_translate_script.onload = function () {
            translate(default_language + "|" + preferred_language);
          };
      }

      sessionStorage.setItem("translate_autoswitch", 1);
    }

    document.querySelectorAll("#translate_options").forEach(function (e) {
      e.value = current_lang;
    });

    document.querySelectorAll(".languageDropdown").forEach(function (e) {
      e.innerHTML = lang_array_english[current_lang];
    });
  }());